import { useCallback } from "react";

import Badge from "ds/components/Badge";
import { BadgeVariant } from "ds/components/Badge/types";
import { VersionState } from "types/generated";
import TooltipInfo from "ds/components/TooltipInfo";

type ModuleVersionStateBadgeProps = {
  state: VersionState | null | undefined;
  yanked?: boolean | null;
  number: string | null | undefined;
  className?: string;
  infoText?: string | null | undefined;
};

const ModuleVersionStateBadge = ({
  state,
  className,
  number,
  yanked,
  infoText,
}: ModuleVersionStateBadgeProps) => {
  const MemoizedTooltip = useCallback(
    () => <TooltipInfo>{infoText}</TooltipInfo>,
    [infoText]
  );

  let variant = BadgeVariant.blue;

  if (yanked || state === VersionState.Failed) {
    variant = BadgeVariant.red;
  } else if (state === VersionState.Pending) {
    variant = BadgeVariant.yellow;
  } else if (state === VersionState.Active) {
    variant = BadgeVariant.green;
  }

  let text = "NEW";

  if (number) {
    text = number;
  }

  return (
    <Badge
      textEllipsis
      variant={variant}
      type="strong"
      className={className}
      text={text}
      startIcon={infoText ? MemoizedTooltip : undefined}
    />
  );
};

export default ModuleVersionStateBadge;
